document.addEventListener('DOMContentLoaded', () => {
  const headerMenus = document.querySelectorAll('header-menu');

  headerMenus.forEach((menu) => {
    const details = menu.querySelector('details');
    const summary = menu.querySelector('summary');

    let isPinned = false;
    let wasOpenedByHover = false;

    menu.addEventListener('mouseenter', () => {
      if (window.innerWidth >= 990 && !isPinned) {
        details.setAttribute('open', '');
        wasOpenedByHover = true;
      }
    });

    menu.addEventListener('mouseleave', () => {
      if (window.innerWidth >= 990 && !isPinned) {
        details.removeAttribute('open');
        wasOpenedByHover = false;
      }
    });

    details.addEventListener('toggle', () => {
      const isOpen = details.hasAttribute('open');

      if (isOpen && !wasOpenedByHover) {
        isPinned = true;
      } else if (!isOpen) {
        isPinned = false;
        wasOpenedByHover = false;
      }
    });

    summary.addEventListener('click', (event) => {
      if (event.detail !== 0) {
        event.preventDefault();
      }
    });
  });
});
